<template>
  <basic-container>
    <el-dialog
      title="任务明细"
      :visible.sync="openFlag"
      :modal-append-to-body="false"
      width="70%"
      @closed="handleClose"
      append-to-body
    >
    <avue-crud
                :option="option"
                :table-loading="loading"
                :data="data"
                :page.sync="page"
                :permission="permissionList"
                :before-open="beforeOpen"
                v-model="form"
                ref="crud"
                @row-update="rowUpdate"
                @row-save="rowSave"
                @row-del="rowDel"
                @search-change="searchChange"
                @search-reset="searchReset"
                @selection-change="selectionChange"
                @current-change="currentChange"
                @size-change="sizeChange"
                @on-load="onLoad"
                @refresh-change="onLoad"
    >
      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          icon="el-icon-view"
          v-if="permission.examinetask_view"
          @click="openExamineTaskViewDialog(scope.row)"
        >查看
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      width="60%"
      title="查看"
      :visible.sync="openExamineTaskViewDialogFlag"
      v-if="openExamineTaskViewDialogFlag"
      append-to-body
      @close="quitexamineTaskViewDialog"
    >
      <div
        class="el-property-dialog-div">
        <avue-form
          ref="examineTaskViewFormRef"
          v-model="examineTaskViewForm"
          :option="examineTaskViewOption"
        >
          <template  slot="test" slot-scope="scope">
            <avue-crud :data="viewTopicData" :option="topicOption"></avue-crud>
          </template>
          <template slot="testLabel" slot-scope="row">
            <span>检查内容:</span>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    </el-dialog>
  </basic-container>
</template>

<script>
  import {add, getDetail, getList, remove, update, getTopicList} from "@/api/crmedical/examine/task/examinetask";
  import {mapGetters} from "vuex";
  import  examineTaskViewOption from './examinetask-view-option';

  export default {
    data: function () {
      return {
        form: {},
        query: {},
        loading: true,
        openFlag:false,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        projectList: [],
        viewTopicData:[],
        examineTaskViewForm: {},
        examineTaskViewOption: examineTaskViewOption,
        openExamineTaskViewDialogFlag: false,
        option: {
          height: 'auto',
          calcHeight: 50,
          indexLabel:'序号',
          tip: false,
          border: true,
          index: true,
          viewBtn: false,
          selection: true,
          editBtn: false,
          addBtn: false,
          delBtn: false,
          columnBtn: false,
          refreshBtn: false,
          searchMenuSpan: 6,
          column: [
            {
              label: "主键",
              prop: "id",
              editDisplay: false,
              addDisplay: false,
              viewDisplay: false,
              hide: true,
            },
            {
              label: "任务名称",
              prop: "name",
              search: true,
              maxlength: 30,
              showWordLimit: true,
              overHidden: true,
            },
            {
              label: "填报组织",
              prop: "deptName",
            },
            {
              label: "填报人",
              prop: "realName",
              search: true,
              maxlength: 30,
              showWordLimit: true,
              overHidden: true,
            },
            {
              label: "用户id",
              prop: "submitUserId",
              editDisplay: false,
              addDisplay: false,
              viewDisplay: false,
              hide: true,
            },
            {
              label: "任务状态",
              prop: "processStatus",
              type: 'select',
              dataType: 'number',
              search: true,
              dicUrl: 'api/blade-system/dict/dictionary?code=task_process_status',
              props: {label: 'dictValue', value: 'dictKey'},
            },
            {
              label: "提交时间",
              prop: "submitTime",
            },
            {
              label: "反馈建议",
              prop: "description",
              hide: true,
            },
            {
              label: '提交日期',
              prop: 'dateStartRange',
              searchRange: true,
              search: true,
              searchSpan: 10,
              type: 'datetimerange',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              editDisplay: false,
              addDisplay: false,
              viewDisplay: false,
              span: 16,
              hide: true,
            },
          ]
        },
        topicOption: {
          calcHeight: 50,
          height: '400',
          indexLabel:'序号',
          page: false,
          border: true,
          addBtn: false,
          selection: false,
          tip: false,
          columnBtn: false,
          refreshBtn: false,
          menuAlign: 'center',
          menu: false,
          column: [
            {
              label: "标准内容",
              overHidden: true,
              prop: "content",
              rules: [{
                required: true,
                message: "请输入考核标准内容",
                trigger: "change"
              }]
            },
            {
              label: "考核要求",
              overHidden: true,
              prop: "demand",
            },
            {
              label: "分数",
              prop: "score",
            },
            {
              label: "排序",
              prop: "sort",
            },
            {
              label: "评分",
              prop: "evaluateScore",
            },
            {
              label: "描述",
              prop: "description",
              overHidden: true,
            },
          ]
        },
        data: []
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.examinetask_add, false),
          viewBtn: this.vaildData(this.permission.examinetask_view, false),
          delBtn: this.vaildData(this.permission.examinetask_delete, false),
          editBtn: this.vaildData(this.permission.examinetask_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    methods: {
      //打开弹窗--------------------------------------------------------------------
      openExamineTaskViewDialog(row){
        setTimeout(()=>{
          this.examineTaskViewForm = row;
          //根据任务id、填报人id获取关联题目
            getTopicList({taskId:row.id}).then((res) => {
              this.viewTopicData = res.data;
              if (res.data){
                let sum = 0;
                res.data.forEach(item=>{
                  sum+= item.evaluateScore;
                });
                this.examineTaskViewForm.sum = sum;
              }
            });

        },500)
        this.openExamineTaskViewDialogFlag = true;
      },
      //关闭弹窗=================================================================
      quitexamineTaskViewDialog(){
        this.examineTaskViewForm = {};
        this.viewTopicData = [];
        this.openExamineTaskViewDialogFlag = false;
      },
      getProjectNameById(projectId) {
        let projectName = '';
        this.projectList.forEach(function (value, index, array) {
          if (value.id === projectId) {
            projectName = value.name;
            return;
          }
        });
        return projectName;
      },
      rowSave(row, loading, done) {
        add(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowUpdate(row, index, loading, done) {
        update(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (["edit", "view"].includes(type)) {
          getDetail({id:this.form.id}).then(({data}) => {
            this.form = data;
          });
        }
        done();
      },
      searchReset() {
        this.query.serviceType = '';
        this.query.processStatus =  '';
        this.query.name = '';
        this.query.groupName = '';
        this.query.dateStartRange = [];
        this.query.realName = '';
        this.onLoad();
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        done();
        this.onLoad();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        if (this.query.dateStartRange) {
          this.query.timeStart = this.query.dateStartRange[0];
          this.query.timeEnd = this.query.dateStartRange[1];
          this.query.dateStartRange = '';
        }
        this.query.taskMainId = this.taskMainId;
        this.query.informantType = this.informantType;
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      },
      openSystemTypeDialog(row) {
        this.taskMainId = row.id;
        this.informantType = row.informantType;
        this.query.taskMainId = row.id;
        this.query.informantType = row.informantType;
        this.onLoad();
        this.openFlag = true;
      },
    }
  };
</script>

<style>
</style>
